import { Pipe, PipeTransform } from '@angular/core';
import { Resource } from '@klickdata/core/resource';

@Pipe({
    name: 'resourceStatus',
})
export class ResourceStatusPipe implements PipeTransform {
    grey = '#b6b6b6';
    orange = '#ff9961';
    red = '#e44a66';
    white = '#fff';
    darkblue = '#3e5365';
    green = '#bfd8d0';
    iceblue = '#93cbd1';
    transform(res: Resource, isStatsContext?: boolean | string): { status: string; color: string; icon: string } {
        const strContext = typeof isStatsContext === 'string';
        if (isStatsContext || strContext) {
            const status = strContext ? isStatsContext : res.occasionStatus;
            switch (status) {
                case 'created':
                    return {
                        status: $localize`:@@created:Created`,
                        color: this.iceblue,
                        icon: 'edit',
                    };
                case 'done':
                    return { status: $localize`:@@completedSingular:Completed`, color: this.green, icon: 'task_alt' };
                case 'completed': // pending_signoff
                    return { status: $localize`:@@unsiged:Unsigned`, color: this.orange, icon: 'done_all' };
                case 'ended':
                    return { status: $localize`:@@ended:Ended`, color: this.darkblue, icon: 'check_circle' };
                case 'ongoing':
                    return { status: $localize`:@@ongoing:Ongoing`, color: this.orange, icon: 'cached' };
                case 'not_started':
                    return {
                        status: $localize`:@@notStarted:Not Started`,
                        color: this.darkblue,
                        icon: 'directions_run',
                    };
                case 'overdue':
                    return { status: $localize`:@@overdue:Overdue`, color: this.red, icon: 'event_busy' };
                case 'cancelled':
                    return { status: $localize`:@@cancelled:Cancelled`, color: this.red, icon: 'cancel' };
                case 'failed':
                    return { status: $localize`:@@failed:Failed`, color: this.red, icon: 'report' };
                case 'deleted':
                    return { status: $localize`:@@deleted:Deleted`, color: this.red, icon: 'delete_forever' };
            }
        } else {
            if (!res.isAvailable()) {
                return { status: $localize`Expired`, color: this.red, icon: 'event_busy' };
            } else if (!res.last_publish) {
                return { status: $localize`Draft`, color: this.grey, icon: 'public_off' };
            } else if (res.public) {
                return { status: $localize`Public`, color: this.darkblue, icon: 'public' };
            } else if (!res.public) {
                return { status: $localize`:@@academy:Academy`, color: this.iceblue, icon: 'published_with_changes' };
            }
        }
    }
}
